import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getServiceChargeSettings,
  updateServiceChargeSettings,
} from "@/api/online-ordering/settings/service-charge";

export const fetchServiceChargeSettings = createAsyncThunk(
  "serviceCharge/fetch",
  async (restaurantId, { rejectWithValue }) => {
    const response = await getServiceChargeSettings(restaurantId);
    if (response?.status === "success") return response.data;
    return rejectWithValue(response?.message || "Failed to fetch service charge settings");
  }
);

export const saveServiceChargeSettings = createAsyncThunk(
  "serviceCharge/save",
  async ({ restaurantId, data }, { rejectWithValue }) => {
    const response = await updateServiceChargeSettings(restaurantId, data);
    if (response?.status === "success") return response.data;
    return rejectWithValue(response?.message || "Failed to update service charge settings");
  }
);

const initialState = {
  serviceCharge: {
    pickup_enabled: true,
    delivery_enabled: true,
    pickup_service_charge_enabled: true,
    delivery_service_charge_enabled: true,
    pickup_service_charge: 0,
    delivery_service_charge: 0,
  },
  getLoading: false,
  saveLoading: false,
  error: null,
  success: null,
};

const serviceChargeSlice = createSlice({
  name: "serviceCharge",
  initialState,
  reducers: {
    clearServiceChargeMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchServiceChargeSettings.pending, (state) => {
        state.getLoading = true;
        state.error = null;
      })
      .addCase(fetchServiceChargeSettings.fulfilled, (state, action) => {
        state.getLoading = false;
        state.serviceCharge = action.payload || initialState.serviceCharge;
      })
      .addCase(fetchServiceChargeSettings.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload || "Failed to fetch service charge settings";
      })
      // Save
      .addCase(saveServiceChargeSettings.pending, (state) => {
        state.saveLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(saveServiceChargeSettings.fulfilled, (state, action) => {
        state.saveLoading = false;
        state.serviceCharge = action.payload || state.serviceCharge;
        state.success = "Service charge settings updated successfully";
      })
      .addCase(saveServiceChargeSettings.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.payload || "Failed to update service charge settings";
      });
  },
});

export const { clearServiceChargeMessages } = serviceChargeSlice.actions;
export default serviceChargeSlice.reducer;
